import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

const ICONS: Record<string, string[]> = {
  calendar: [
    'M3 7a2.5 2.5 0 0 1 2.5-2.5h13A2.5 2.5 0 0 1 21 7v11.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5z',
    'M8 2.5v4M16 2.5v4M3 9.5h18',
  ],
  'calendar-heart': [
    'M3 7a2.5 2.5 0 0 1 2.5-2.5h13A2.5 2.5 0 0 1 21 7v11.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5z',
    'M8 2.5v4M16 2.5v4M3 9.5h18',
    'M12 18.2l-2.6-2.5a1.6 1.6 0 0 1 2.6-1.9 1.6 1.6 0 0 1 2.6 1.9z',
  ],
  clock: ['M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18z', 'M12 7.5V12l3 2'],
  pin: [
    'M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z',
    'M12 7.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5z',
  ],
  navigate: ['M3.5 11L20.5 3.5 13 20.5l-2-7.5z'],
  user: ['M12 4a4 4 0 1 0 0 8a4 4 0 1 0 0-8z', 'M4 20.5a8 8 0 0 1 16 0'],
  users: [
    'M9 4.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 1 0 0-7z',
    'M2.5 20.5v-1a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v1',
    'M16 4.6a3.5 3.5 0 0 1 0 6.8M21.5 20.5v-1a5 5 0 0 0-3.5-4.8',
  ],
  home: ['M3.5 10.5L12 3.5l8.5 7', 'M5.5 9v11h13V9', 'M10 20v-5.5h4V20'],
  cake: [
    'M4 21h16',
    'M5 21v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7',
    'M5 16.5c1.2 0 1.8-1 3.5-1s2.3 1 3.5 1 1.8-1 3.5-1 2.3 1 3.5 1',
    'M12 12V8.5',
    'M12 3.5c.8 1 1.2 1.7 1.2 2.4a1.2 1.2 0 0 1-2.4 0c0-.7.4-1.4 1.2-2.4z',
  ],
  euro: ['M17.5 6.2a7 7 0 1 0 0 11.6', 'M4 10.5h9M4 13.5h9'],
  car: [
    'M5 17h14v-4.5l-1.8-4.6A2 2 0 0 0 15.3 6.5H8.7a2 2 0 0 0-1.9 1.4L5 12.5z',
    'M5 12.5h14M7.5 17v2.5M16.5 17v2.5',
  ],
  phone: [
    'M20.5 16.4v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 .6 3.7 2 2 0 0 1 2.6 1.5h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L6.6 9.4a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z',
  ],
  mail: [
    'M3 6.5A1.5 1.5 0 0 1 4.5 5h15A1.5 1.5 0 0 1 21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5z',
    'M3.5 6l8.5 7 8.5-7',
  ],
  chat: ['M20.5 11.5a8.5 8.5 0 0 1-12.4 7.6L3.5 20.5l1.4-4.4A8.5 8.5 0 1 1 20.5 11.5z'],
  share: ['M12 3v12', 'M7.5 7.5L12 3l4.5 4.5', 'M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7'],
  more: ['M5 12h.01M12 12h.01M19 12h.01'],
  trash: ['M4 7h16', 'M9.5 7V4.5h5V7', 'M6.5 7l1 13h9l1-13', 'M10 11v5.5M14 11v5.5'],
  plus: ['M12 5v14M5 12h14'],
  camera: [
    'M4 8a2 2 0 0 1 2-2h2l1.5-2h5L16 6h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z',
    'M12 9.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 1 0 0-7z',
  ],
  note: ['M4 4h16v10l-6 6H4z', 'M14 20v-6h6'],
  file: [
    'M14 2.5H6.5A2 2 0 0 0 4.5 4.5v15a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8z',
    'M14 2.5V8h5.5M8.5 13h7M8.5 17h5',
  ],
  card: ['M2.5 7.5A2.5 2.5 0 0 1 5 5h14a2.5 2.5 0 0 1 2.5 2.5v9A2.5 2.5 0 0 1 19 19H5a2.5 2.5 0 0 1-2.5-2.5z', 'M2.5 10h19M6.5 15h3'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  send: ['M21 3L10 14', 'M21 3l-6.5 18-4.5-7-7-4.5z'],
  edit: ['M4 20h4L19 9l-4-4L4 16z', 'M13.5 6.5l4 4'],
  eye: ['M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z', 'M12 9a3 3 0 1 0 0 6a3 3 0 1 0 0-6z'],
  download: ['M12 3v12', 'M7.5 10.5L12 15l4.5-4.5', 'M4 20h16'],
  sparkle: ['M12 3l1.8 5.4L19 10l-5.2 1.6L12 17l-1.8-5.4L5 10l5.2-1.6z', 'M19 16l.7 2.1 2.1.7-2.1.7L19 21.6l-.7-2.1-2.1-.7 2.1-.7z'],
  lock: ['M5.5 11h13v9.5h-13z', 'M8 11V7.5a4 4 0 0 1 8 0V11'],
  globe: [
    'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18z',
    'M3 12h18',
    'M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z',
  ],
  bell: ['M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z', 'M10 20.5a2 2 0 0 0 4 0'],
  settings: [
    'M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z',
    'M12 9a3 3 0 1 0 0 6a3 3 0 1 0 0-6z',
  ],
  chart: ['M4 20.5h16', 'M7 16.5v-5M12 16.5V6M17 16.5v-8'],
  handshake: [
    'M11 17l2 2a1 1 0 1 0 3-3',
    'M14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4',
    'M21 3l1 11h-2',
    'M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3',
    'M3 4h8',
  ],
  rings: [
    'M9 9a5.5 5.5 0 1 0 0 11a5.5 5.5 0 1 0 0-11z',
    'M15 9a5.5 5.5 0 1 0 0 11a5.5 5.5 0 1 0 0-11z',
    'M7.5 3h3l1 1.8-2.5 2.7-2.5-2.7z',
  ],
  scissors: [
    'M6 3.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5z',
    'M6 15.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5z',
    'M20 4L8.1 15.1M14.5 14.5L20 20M8.1 8.9L12 12',
  ],
  lipstick: ['M8.5 13h7v8h-7z', 'M9.5 13V8.5L14.5 4.5V13'],
  paperclip: [
    'M21.4 11.1l-9.2 9.2a6 6 0 0 1-8.5-8.5l8.6-8.6A4 4 0 1 1 18 8.8l-8.6 8.6a2 2 0 0 1-2.8-2.8l8.5-8.5',
  ],
  logout: ['M9 20.5H5.5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2H9', 'M16 16.5l4.5-4.5L16 7.5', 'M20.5 12H9'],
  search: ['M11 4a7 7 0 1 0 0 14a7 7 0 1 0 0-14z', 'M20.5 20.5L16 16'],
  map: ['M3.5 6.5L9 4l6 2.5L20.5 4v13.5L15 20l-6-2.5-5.5 2.5z', 'M9 4v13.5M15 6.5V20'],
  alert: [
    'M10.3 4.3a2 2 0 0 1 3.4 0l7.6 13.2a2 2 0 0 1-1.7 3H4.4a2 2 0 0 1-1.7-3z',
    'M12 9.5v4M12 17h.01',
  ],
  sign: ['M3.5 20.5h17', 'M14.5 4.5l3 3L8 17H5v-3z'],
  hourglass: [
    'M6 3h12M6 21h12',
    'M7 3v2.5c0 2 1.5 3.5 5 6.5 3.5-3 5-4.5 5-6.5V3',
    'M7 21v-2.5c0-2 1.5-3.5 5-6.5 3.5 3 5 4.5 5 6.5V21',
  ],
  folder: ['M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
  gift: [
    'M4 9.5h16v3H4z',
    'M5.5 12.5V20h13v-7.5',
    'M12 9.5V20',
    'M12 9.5C10.5 6 7 5.5 7 7.5s3 2 5 2zM12 9.5c1.5-3.5 5-4 5-2s-3 2-5 2z',
  ],
  bank: ['M3.5 9.5L12 4.5l8.5 5', 'M4 20.5h16', 'M6 12v6M10 12v6M14 12v6M18 12v6'],
  palette: [
    'M12 3a9 9 0 1 0 0 18c1.2 0 1.8-.8 1.8-1.7 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-.9.8-1.7 1.7-1.7h2A4.5 4.5 0 0 0 21 10.7C21 6.4 17 3 12 3z',
    'M7.5 11.5h.01M9.5 7.5h.01M14.5 7.5h.01',
  ],
  calculator: [
    'M6.5 2.5h11A1.5 1.5 0 0 1 19 4v16a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 20V4a1.5 1.5 0 0 1 1.5-1.5z',
    'M8.5 6h7v3h-7z',
    'M9 13h.01M12 13h.01M15 13h.01M9 17h.01M12 17h.01M15 17h.01',
  ],
  key: ['M7.5 11.5a4 4 0 1 0 0 8a4 4 0 1 0 0-8z', 'M10.5 12.5L20 3', 'M16.5 6.5L19 9', 'M14 9l2 2'],
  zap: ['M13 2.5L4.5 13.5H12l-1 8 8.5-11H12z'],
  shield: ['M12 3l7.5 3v5.5c0 4.5-3.2 8-7.5 9.5-4.3-1.5-7.5-5-7.5-9.5V6z'],
  copy: [
    'M10.5 9h9A1.5 1.5 0 0 1 21 10.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 9 19.5v-9A1.5 1.5 0 0 1 10.5 9z',
    'M5 15h-.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V5',
  ],
  'x-circle': ['M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18z', 'M9 9l6 6M15 9l-6 6'],
  upload: ['M12 15V3', 'M7.5 7.5L12 3l4.5 4.5', 'M4 20h16'],
  'chevron-down': ['M6 9l6 6 6-6'],
  x: ['M6 6l12 12M18 6L6 18'],
};

const HEAVY = new Set(['more']);

export function iconSvg(name: string, size = 14): string {
  const paths = (ICONS[name] ?? []).map((d) => `<path d="${d}"/>`).join('');
  const sw = HEAVY.has(name) ? 3 : 1.8;
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px;flex-shrink:0">${paths}</svg>`;
}

@Component({
  selector: 'app-icon',
  imports: [CommonModule],
  template: `<svg
    [attr.width]="size"
    [attr.height]="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    [attr.stroke-width]="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  ><path *ngFor="let d of paths" [attr.d]="d" /></svg>`,
  styles: [':host { display: inline-flex; flex-shrink: 0; line-height: 0; vertical-align: -0.15em; }'],
})
export class IconComponent {
  @Input() name = '';
  @Input() size: number | string = 18;

  get paths(): string[] {
    return ICONS[this.name] ?? [];
  }

  get strokeWidth(): number {
    return HEAVY.has(this.name) ? 3 : 1.8;
  }
}
